import React, { useEffect, useState } from 'react';
import { Navigate, useParams, useNavigate } from 'react-router-dom';
import { isAuthenticated } from '../services/authService';
import { useUser } from '../contexts/UserContext';
import { useTenant } from '../contexts/TenantContext';
import { useTranslation } from 'react-i18next';

const ProtectedRouteTenant = ({ children }) => {
  const { t } = useTranslation();
  const { loadingUser } = useUser();
  const { tenant_id } = useParams();
  const { tenantData, loadingTenant } = useTenant();
  const [isLoadingTimeout, setIsLoadingTimeout] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated()) {
      console.warn('ProtectedRouteTenant: Token is expired or missing. Redirecting to login.');
      // navigate(`/app/${tenant_id}/login`, { replace: true });
      // return;
      if (localStorage.getItem("LOGIN_PAGE")) {
        const loginPage = localStorage.getItem("LOGIN_PAGE");
        console.log("ProtectedRouteTenant: Redirecting to saved login page:", `${loginPage}login`);
        navigate(`${loginPage}login`);
        return;
      }
      console.log("ProtectedRouteTenant: Redirecting to default login page");
      navigate(`/app/${tenant_id}/login`); // Redirect to tenant-specific login if not authenticated
      return;
    }

    const timeout = setTimeout(() => {
      if (loadingUser || loadingTenant) {
        console.warn('ProtectedRouteTenant: loading state is taking too long. Forcing redirection check.');
        setIsLoadingTimeout(true);
      }
    }, 5000); // 5-second timeout

    return () => clearTimeout(timeout);
  }, [loadingUser, loadingTenant, tenant_id, navigate]);

  // if (loadingTenant || !tenantData) {
  //   console.log('ProtectedRoute: Tenant data is still loading.');
  //   return (
  //     <div style={{ textAlign: 'center', marginTop: '20px' }}>
  //       <p>Loading tenant data...</p>
  //     </div>
  //   );
  // }

  // if (loadingUser || loadingTenant) {
  //   console.log('ProtectedRoute: User or tenant data is still loading.');
  //   return (
  //     <div style={{ textAlign: 'center', marginTop: '20px' }}>
  //       <p>Loading user and tenant data...</p>
  //     </div>
  //   );
  // }

  // if (!isAuthenticated()) {
  //   console.warn('ProtectedRouteTenant: Token is expired or missing. Redirecting to login.');
  //   return <Navigate to={`/app/${tenant_id}/login`} replace />;
  // }

  // // Affiche un loader tant que tenant_id ou tenantData ne sont pas définis
  // if (!tenant_id || !tenantData || loadingTenant) {
  //   return (
  //     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
  //       <img
  //         src="/logo_banane_transparent.png"
  //         alt="Logo"
  //         style={{
  //           width: '150px',
  //           marginBottom: '20px',
  //           animation: 'zoomInOut 1.5s ease-in-out infinite'
  //         }}
  //       />
  //       <p>{t('loading.loading', 'Nous bananons au plus vite !')}</p>
  //       <style>
  //         {`
  //           @keyframes zoomInOut {
  //             0% { transform: scale(1); }
  //             50% { transform: scale(1.15); }
  //             100% { transform: scale(1); }
  //           }
  //         `}
  //       </style>
  //     </div>
  //   );
  // }

  // Exécute la comparaison uniquement si les deux valeurs sont définies
  // if (tenant_id !== tenantData.subdomain_prefix) {
  //   console.error(
  //     `ProtectedRoute: Mismatched tenant_id. Expected: ${tenantData.subdomain_prefix}, Found: ${tenant_id}`
  //   );
  //   return <Navigate to={`/app/${tenantData.subdomain_prefix}/dashboard`} replace />;
  // }

  console.log('ProtectedRouteTenant: User is authenticated and tenant_id matches. Rendering children.');
  // return children;
  return (
    <>
      {(loadingTenant || !tenantData) ? (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
          <img
            src="/logo_banane_transparent.png"
            alt="Logo"
            style={{
              width: '150px',
              marginBottom: '20px',
              animation: 'zoomInOut 1.5s ease-in-out infinite' // Effet zoom/dézoom
            }}
          />
          <p>{t('loading.loading', 'Nous bananons au plus vite !')}</p>
          <p style={{ color: 'white' }}>loading tenantData: {JSON.stringify(tenantData)} || loadingTenant: {loadingTenant}</p>
          <style>
            {`
              @keyframes zoomInOut {
                0% {
                  transform: scale(1);
                }
                50% {
                  transform: scale(1.15);
                }
                100% {
                  transform: scale(1);
                }
              }
            `}
          </style>
        </div>
      ) : (
        children
      )}
    </>
  );
};

export default ProtectedRouteTenant;
